import { IAddress } from "../domain/group/address";
import { getCountryByCode } from "./Countries";
import { TranslateFunc } from "./translation.utils";

export const translateCountryByCode = (countryCode: string, translate: TranslateFunc) => {
  const country = getCountryByCode(countryCode);
  if (!country) {
    return translate("basedata.addresses.table.noEntry");
  }
  return translate(country.translationKey);
};

export const getAddressBaseTextParts = (address: IAddress, t: TranslateFunc): string[] => {
  const textParts: string[] = [];

  if (address.address && address.buildingNumber) {
    textParts.push(`${address.address} ${address.buildingNumber}`);
  }
  if (address.postal && address.city) {
    textParts.push(` ${address.postal} ${address.city}`);
  }
  if (address.country) {
    textParts.push(` ${translateCountryByCode(address.country, t)}`);
  }

  return textParts;
};
